import { render, staticRenderFns } from "./BloquePlegable.vue?vue&type=template&id=78da3010&scoped=true"
import script from "./BloquePlegable.vue?vue&type=script&lang=js"
export * from "./BloquePlegable.vue?vue&type=script&lang=js"
import style0 from "./BloquePlegable.vue?vue&type=style&index=0&id=78da3010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78da3010",
  null
  
)

export default component.exports